<template>
  <div class="log">
    <list-block>
      <div class="log-desc">
        <LogListFilter
          :form="form"
          @search="handleSearch"
          @back="$router.push('/userCenter/operationControl')"
          @export="exportLog()"
        />
        <el-descriptions
          :title="title"
          size="small"
          :colon="false"
        >
          <el-descriptions-item label="">
            <span class="log-tips"><i class="el-icon-info" />  管控人员{{ statisticData.totalPersonNum }}人，执行人员{{ statisticData.executePersonNum }}人，未执行人员{{ statisticData.notExecutePersonNum }}人，人员执行率{{ statisticData.executeRateStr }}</span>
          </el-descriptions-item>
        </el-descriptions>
      </div>
      <ProTable
        :data="list"
        :columns="LOG_TABLE_COLUMN"
        :pagination.sync="pagination"
        :loading="loading"
      >
        <template #status="{row}">
          <div v-if="row.status==='EXECUTE_SUCCESS'" class="success">
            <span />通过
          </div>
          <div v-else-if="row.status==='EXECUTE_FAIL'" class="fail">
            <span />
            不通过
          </div>
          <div v-else class="none">
            <span />
            未操作
          </div>
        </template>
        <template #taskType="{row}">
          <div>{{ currentatterLabel(row.taskType, TASK_LIST) }}</div>
        </template>
      </ProTable>
    </list-block>
  </div>
</template>
<script>
import ListBlock from '@/components/ListBlock/index.vue';
import {
  controlPage, fetchLogDataPage, download, fetchLogStatisticData,
} from '@/api/userControl';
import ProTable from '@/components/ProTable/index.vue';
import { getPermissionSystemPage } from '@/api/unifyUser';
import { searchFormFilter } from '@/utils';
import LogListFilter from './components/LogListFilter.vue';
import {
  LOG_TABLE_COLUMN, TASK_LIST,
} from './constant';

const typeMap = {
  EQUIPMENT: '设备',
  IP: 'IP',
  FACE: '人脸',
};

const initSearchForm = () => ({
  unifyNameLike: '',
  mobile: '',
  dateRange: [],
  companyIds: [],
  taskType: '',
  status: '',
});

export default {
  name: 'Log',
  components: {
    ListBlock,
    ProTable,
    LogListFilter,
  },
  data() {
    return {
      unifyId: null,
      pagination: {
        total: 0,
        pageSize: 10,
        currentPage: 1,
      },
      loading: false,
      details: {},
      list: [],
      statisticData: {
        totalPersonNum: '0',
        executePersonNum: '0',
        notExecutePersonNum: '0',
        notExecuteNum: '0',
        executeRate: '0',
        executeRateStr: '0%',
        totalTaskNum: '0',
        executeTaskNum: '0',
        notExecuteTaskNum: '0',
        executeTaskRate: '0',
        executeTaskRateStr: '0%',
      },
      LOG_TABLE_COLUMN,
      TASK_LIST,
      show: true,
      title: '卡控日志',
      systemOptions: [],
      form: initSearchForm(),
    };
  },
  watch: {
    pagination() {
      this.fetchData();
    },
  },
  created() {
    this.unifyId = this.$route.query.unifyId;
    if (!this.unifyId) {
      this.show = false;
      this.title = '';
    } else {
      this.fetchDetailsData();
    }
    this.fetchData();
    this.fetchStatisticData();
  },
  methods: {
    exportLog() {
      const url = '/bfs-user/control/log/export';
      const name = 'export';
      const data = { };
      if (this.unifyId) {
        data.unifyId = this.unifyId;
      }
      download(name, url, data);
    },
    currentatterLabel(val, list) {
      if (!val) return val;
      const [temp] = list.filter((item) => item.value === val);
      if (temp) return temp.label;
      if (val === 'IMMEDIATE_EXECUTION') return '立即执行';
      if (val === 'ONE_TIME') return '一次';
      return temp ? temp.label : val;
    },
    async fetchData() {
      this.loading = true;
      try {
        const [executeDateGe, executeDateLe] = (this.form.dateRange && this.form.dateRange.length) ? this.form.dateRange : ['', ''];
        const data = {
          unifyId: this.unifyId, ...this.form, executeDateGe, executeDateLe,
        };
        const params = {
          page: this.pagination.currentPage,
          size: this.pagination.pageSize,
        };
        const dataTemp = searchFormFilter(data);
        const resp = await fetchLogDataPage(dataTemp, params);
        this.pagination.total = resp.total;
        this.list = resp.records;
      } finally {
        this.loading = false;
      }
    },
    async fetchStatisticData() {
      const data = { unifyId: this.unifyId };
      const params = {};
      const resp = await fetchLogStatisticData(data, params);
      if (resp) {
        this.statisticData = resp;
      }
    },
    async fetchDetailsData() {
      const data = {
        unifyId: this.unifyId,
        needConfigDetail: true,
      };
      const params = {
        page: 1,
        size: 10,
      };
      const resp = await controlPage(data, params);
      this.details = resp.records?.[0];
      const respD = await getPermissionSystemPage({}, { size: 9999 });
      this.systemOptions = respD.records;
      this.systemLabelMap();
      this.handleVal();
    },
    systemLabelMap() {
      const res = [];
      this.systemOptions.forEach((item) => {
        if (this.details.controlSystem?.includes(item.systemCode)) { res.push(item.name); }
      });
      this.details.controlSystem = res.join(',');
    },
    handleVal() {
      const resMap = {};
      this.details.details.forEach((item) => {
        if (!resMap[item.controlType]) {
          resMap[item.controlType] = {
            total: 1,
            enabled: item.availableStatus === 'ENABLED' ? 1 : 0,
            type: item.controlType,
          };
        } else {
          resMap[item.controlType].total += 1;
          if (item.availableStatus === 'ENABLED') {
            resMap[item.controlType].enabled += 1;
          }
        }
      });
      this.details.controlType = Object.values(resMap).map((item) => `${typeMap[item.type]}:${item.enabled}/${item.total}`).join('\n');
    },
    handleSearch() {
      this.fetchData();
    },
  },
};
</script>
<style scoped lang="scss">
.log{
    .log-desc{
        overflow: hidden;
        .el-button{
            float: right;
            position: relative;
            bottom: 35px;
        }
       .el-descriptions{
        margin-top: 25px;
        :deep(.el-descriptions__title){
            border-left: 3px solid #1e3cbb;
            line-height: 13px;
            padding-left: 5px;
            font-size: 14px;
            color: #1e3cbb;
        }
       }
       .line{
            margin: 10px 0 20px 0px;
            border-bottom: 1px solid #eee;
        }
        .log-tips{
            color: #1890ff;
            font-weight: 600;
        }
    }
    .success span, .fail span, .none span{
        display: inline-block;
        width: 10px;
        height: 10px;
        border-radius: 50%;
        background-color: #656262
    }
    .success{
        color: #06B880;
        span{
            background-color: #06B880;
        }
    }
    .fail{
        color: #F2001D;
        span{
            background-color: #F2001D;
        }
    }
}
</style>
